import * as React from "react";
import { SVGProps } from "react";
function SvgValidationErrorIcon(props: SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle cx={8} cy={8} r={8} fill="#EF4444" />
      <path
        d="M7.107 3.2h1.848v6.58H7.107V3.2Zm.896 9.968c-.327 0-.607-.117-.84-.35a1.145 1.145 0 0 1-.35-.84c0-.345.117-.63.35-.854a1.17 1.17 0 0 1 .84-.336c.327 0 .607.112.84.336.233.224.35.509.35.854 0 .327-.117.607-.35.84-.233.233-.513.35-.84.35Z"
        fill="#fff"
      />
    </svg>
  );
}
export default SvgValidationErrorIcon;
